var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationPinDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Location",
  fill: "#41505F",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.98769561,14.3553611 C7.02436084,14.4107373 7.06269268,14.4644354 7.10102452,14.5231677 L11.4441884,19.7073101 C11.5710096,19.8906872 11.7789034,20 12.0008333,20 C12.2227632,20 12.430657,19.8906872 12.5574782,19.7073101 L16.8906425,14.5282019 C16.9323075,14.4694696 16.972306,14.4124154 17.0123044,14.3603953 L17.03897,14.3201217 C18.6606616,11.7936637 18.1891203,8.45080699 15.9328946,6.47891728 C13.6766688,4.50702757 10.3233312,4.50702757 8.06710542,6.47891728 C5.81087966,8.45080699 5.33933836,11.7936637 6.96102998,14.3201217 L6.98769561,14.3553611 Z M12.0008333,8.52743745 C13.3814913,8.52743745 14.5007357,9.65438114 14.5007357,11.0445366 C14.5007357,12.4346921 13.3814913,13.5616358 12.0008333,13.5616358 C10.6201753,13.5616358 9.50093086,12.4346921 9.50093086,11.0445366 C9.50093086,9.65438114 10.6201753,8.52743745 12.0008333,8.52743745 L12.0008333,8.52743745 Z",
  id: "Shape"
})))));
export { SvgLocationPinDark as ReactComponent };
export default __webpack_public_path__ + "static/media/locationPinDark.53eec5ef.svg";